import { render, staticRenderFns } from "./Divisions.vue?vue&type=template&id=1bc0c15e&scoped=true"
import script from "./Divisions.vue?vue&type=script&lang=js"
export * from "./Divisions.vue?vue&type=script&lang=js"
import style0 from "./Divisions.vue?vue&type=style&index=0&id=1bc0c15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0c15e",
  null
  
)

export default component.exports